/* All report surfaces are opt-in; shared primitives and other pages keep their styles. */
.reports-page {
  min-width: 0;
}

.reports-page:has(> .reports-content) {
  max-width: 1344px;
}

.reports-page .reports-content {
  container: reports / inline-size;
}

.reports-page .reports-content,
.reports-page .reports-workspace {
  display: grid;
  min-width: 0;
  gap: 16px;
}

.reports-page .reports-hero {
  position: relative;
  isolation: isolate;
  min-height: 72px;
  padding: 6px 20px;
  overflow: clip;
  border: 1px solid var(--color-line-soft);
  border-radius: 4px;
  background: white;
}

.reports-page .reports-hero::before {
  position: absolute;
  z-index: -1;
  inset: 0 0 0 auto;
  width: 54%;
  max-width: 434px;
  content: "";
  background-image: url("/brand/reports/transia-grain-banner.png");
  background-position: right center;
  background-size: auto 100%;
  background-repeat: no-repeat;
  mask-image: linear-gradient(90deg, transparent 10%, rgb(0 0 0 / 0.025) 18%, rgb(0 0 0 / 0.10) 26%, rgb(0 0 0 / 0.30) 34%, rgb(0 0 0 / 0.60) 42%, rgb(0 0 0 / 0.86) 48%, black 56%);
}

.reports-page .reports-hero > div {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 195px);
  align-items: center;
  gap: 20px;
  padding-right: clamp(330px, 32cqw, 440px);
}

.reports-page .reports-hero h1 {
  font-size: clamp(24px, 2.2cqw, 28px);
  font-weight: 700;
  line-height: 1.12;
  letter-spacing: -0.035em;
}

.reports-page .reports-hero [aria-hidden='true']:has(> svg) {
  width: 32px;
  height: 32px;
}

.reports-page .reports-hero [aria-hidden='true'] > svg {
  width: 20px;
  height: 20px;
}

.reports-page .reports-hero-subtitle {
  display: block;
  margin-top: 0;
  font-size: 13px;
  line-height: 1.4;
  color: var(--color-slate-800);
}

.reports-page .reports-dispatch-date {
  padding: 2px 8px;
  border: 1px solid var(--color-slate-200);
  border-radius: 4px;
  background: rgb(255 255 255 / 0.96);
}

.reports-page .reports-hero .reports-dispatch-date {
  gap: 2px;
}

.reports-page .reports-hero .reports-dispatch-date input {
  min-height: 32px;
}

.reports-page .reports-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: stretch;
  gap: 16px;
  min-width: 0;
}

.reports-page .reports-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 16px;
  padding: 18px;
  border: 1px solid var(--color-slate-200);
  border-radius: 4px;
  background: white;
  box-shadow: 0 2px 8px rgb(15 23 42 / 0.035);
}

.reports-page .reports-card-header {
  display: flex;
  align-items: flex-start;
  min-width: 0;
  gap: 12px;
}

.reports-page .reports-card-header > div:last-child {
  min-width: 0;
}

.reports-page .reports-card-title {
  margin: 2px 0 4px;
  font-size: 19px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.025em;
}

.reports-page .reports-card-icon {
  display: inline-flex;
  flex: 0 0 46px;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 4px;
  background: color-mix(in srgb, var(--color-accent) 8%, white);
  color: var(--color-accent-strong);
}

.reports-page .reports-card-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  min-width: 0;
  gap: 14px;
}

.reports-page .reports-settings {
  display: grid;
  min-width: 0;
  gap: 12px;
}

.reports-page .reports-field,
.reports-page .reports-control {
  display: grid;
  min-width: 0;
  max-width: 100%;
  align-content: start;
  gap: 6px;
}

.reports-page .reports-field {
  width: 100%;
}

.reports-page .reports-label {
  font-size: 13px;
  font-weight: 500;
  line-height: 1.35;
  color: var(--color-slate-900);
}

.reports-page .reports-field :is(input, select) {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  min-height: 36px;
  padding-inline: 10px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
}

.reports-page .reports-options,
.reports-page .reports-option-group {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.reports-page .reports-option-group {
  gap: 4px;
}

.reports-page .reports-option-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  min-height: 34px;
  padding: 6px 9px;
  border-width: 1px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.reports-page .reports-card-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
  margin-top: auto;
  padding-top: 2px;
}

/* Let the existing email and scheduling controls wrap with the PDF button. */
.reports-page .reports-card-actions > .reports-email-actions {
  display: contents;
}

.reports-page .reports-planning-actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
}

.reports-page .reports-card-actions > div,
.reports-page .reports-card-actions button {
  max-width: 100%;
}

.reports-page .reports-card-actions button {
  min-height: 36px;
  border-radius: 4px;
  white-space: normal;
}

.reports-page .reports-primary-action {
  min-width: 0;
  padding: 8px 12px;
  border-color: var(--color-accent) !important;
  background: var(--color-accent) !important;
  color: white !important;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  transform: none !important;
}

.reports-page .reports-primary-action:hover:not(:disabled) {
  border-color: var(--color-accent-strong) !important;
  background: var(--color-accent-strong) !important;
}

.reports-page button:disabled {
  border-color: var(--color-slate-200) !important;
  background: var(--color-slate-50) !important;
  background-image: none !important;
  color: var(--color-slate-400) !important;
  box-shadow: none !important;
  opacity: 1 !important;
  transform: none !important;
}

.reports-page button[aria-busy='true'] > span[aria-hidden='true'] {
  border-color: var(--color-slate-300);
  border-top-color: var(--color-accent);
}

.reports-page :is(button, input, select, textarea, a, [tabindex]):focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.reports-page .reports-orders-filters {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 150px), 1fr));
  min-width: 0;
  gap: 12px;
}

.reports-page .reports-orders-filters > :last-child {
  grid-column: 1 / -1;
}

.reports-page .reports-export-status {
  display: grid;
  min-width: 0;
  gap: 4px;
  padding: 14px;
  border: 1px solid var(--color-slate-200);
  border-radius: 4px;
  background: var(--color-slate-50);
  overflow-wrap: anywhere;
}

.reports-page .reports-history {
  min-width: 0;
  border-color: var(--color-slate-200);
}

.reports-page .reports-history-table th:last-child,
.reports-page .reports-history-table td:last-child {
  width: auto;
}

.reports-page .reports-history-table table {
  min-width: 0;
}

.reports-page .reports-history-table td span {
  white-space: normal;
  overflow-wrap: anywhere;
}

.reports-page :is([role='dialog'], dialog) {
  max-height: calc(100dvh - 48px);
  overflow-y: auto;
  overflow-wrap: anywhere;
}

.reports-page [role='dialog'] :is(input, select, textarea, label) {
  min-width: 0;
  max-width: 100%;
}

.reports-page [role='dialog'] > div:first-child > div {
  min-width: 0;
}

.reports-page [role='dialog'] > div:first-child > button,
.reports-page.reports-orders-dialog > div > div > div:first-child > button {
  flex-shrink: 0;
  white-space: nowrap;
}

.reports-page [role='dialog'] > div:first-child > div > span {
  border-radius: 4px;
}

.reports-page :is([role='dialog'], dialog, .reports-orders-dialog) button,
.reports-page.reports-orders-dialog button,
.reports-page.reports-orders-dialog > div > div {
  border-radius: 4px;
}

.reports-page.reports-orders-dialog input {
  min-width: 0;
  border-radius: 4px;
}

@container reports (min-width: 720px) {
  .reports-page .reports-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .reports-page .reports-history-table th:nth-child(2),
  .reports-page .reports-history-table td:nth-child(2) {
    width: 240px;
  }
}

@container reports (min-width: 1100px) {
  .reports-page .reports-grid {
    grid-template-columns: minmax(0, 1fr) 440px minmax(0, 1fr);
  }
}

@media (max-width: 979px) {
  .reports-page .reports-hero::before {
    display: none;
    background-image: none;
  }

  .reports-page .reports-hero > div {
    padding-right: 0;
  }
}

@media (max-width: 479px) {
  .reports-page.reports-orders-dialog > div > div > div:nth-child(2) > div > div {
    grid-template-columns: minmax(0, 1fr);
  }
}

@container reports (max-width: 719px) {
  .reports-page .reports-hero {
    min-height: 0;
    padding: 12px 16px;
  }

  .reports-page .reports-hero > div {
    grid-template-columns: minmax(0, 1fr);
    gap: 14px;
  }

  .reports-page .reports-hero [aria-hidden='true']:has(> svg) {
    width: 40px;
    height: 40px;
  }

  .reports-page .reports-hero-subtitle {
    font-size: 15px;
  }

  .reports-page .reports-card {
    padding: 16px;
  }

  .reports-page .reports-history > div:first-child > div:first-child {
    min-width: 0;
  }

  .reports-page .reports-history-table :is(table, tbody) {
    display: block;
    width: 100%;
  }

  .reports-page .reports-history-table thead {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
  }

  .reports-page .reports-history-table tr {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding: 10px;
    gap: 8px 12px;
    border-bottom: 1px solid var(--color-slate-200);
  }

  .reports-page .reports-history-table tr:last-child {
    border-bottom: 0;
  }

  .reports-page .reports-history-table td {
    display: block;
    width: auto;
    min-width: 0;
    padding: 0;
    white-space: normal;
  }

  .reports-page .reports-history-table td:nth-child(n + 3) {
    grid-column: 1 / -1;
  }

  .reports-page .reports-history-table td::before {
    display: block;
    margin-bottom: 2px;
    color: var(--color-slate-500);
    content: attr(data-label);
    font-size: 10px;
    font-weight: 600;
  }
}

@container reports (max-width: 359px) {
  .reports-page .reports-orders-filters {
    grid-template-columns: minmax(0, 1fr);
  }
}
